import { z } from "zod";

const SEGMENT_AUDIENCE_REFUSALS = ["segmentNotVisible", "handPickedSegment", "brokenRules", "unsupportedCapability"] as const;
export const SegmentAudienceRefusalSchema = z.enum(SEGMENT_AUDIENCE_REFUSALS);
export type SegmentAudienceRefusal = z.infer<typeof SegmentAudienceRefusalSchema>;
